import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { familyInfoDataFn } from 'src/fetch/stepA';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { dataSet, educationDataSet } from './dataSet';
import _ from 'lodash';
import { error } from 'console';
const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

// SELECT(LIST) 보험료
export const educationInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any,
  familyInfoDataState?: any,
  familyData?: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/educationfee/lst';
  const fetchKey = 'EDUCATION_INFO';
  if (!familyData) {
    familyData = await familyInfoDataFn(errorModalState, param, familyInfoDataState, queryClient);
  }
  const familyDataSet = _.cloneDeep(familyData);
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    const { resError, resData } = educationDataSet(infoData, familyDataSet, null);
    console.log('[educationl_INFO]:', paramSet, data, resData);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// INSERT 보험료
export const fetchInsertEducationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/educationfee/ist';
  const fetchKey = 'EDUCATION_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// UPDATE 보험료
export const fetchUpdateEducationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/educationfee/upd';
  const fetchKey = 'EDUCATION_UPDATE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// DELETE 보험료
export const fetchDeleteEducationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/educationfee/del';
  const fetchKey = 'EDUCATION_DELETE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
